import React, { useState } from 'react';
import { EditOutlined } from '@mui/icons-material';
import { InputBase, Tab, type TabProps } from '@mui/material';
import { useZitoneoServices } from '../../../contexts/ZitoneoContentContext';

interface ServiceInstanceTabProps extends Omit<TabProps, 'id'> {
    id: string;
    name?: string;
    serviceName: string;
    index: number;
    isActive: boolean;
    isDisabled: boolean;
}

const ServiceInstanceTab = ({
    id,
    name,
    serviceName,
    index,
    isActive,
    isDisabled,
    ...tabProps
}: ServiceInstanceTabProps) => {
    const { handleEditServiceContent } = useZitoneoServices();
    const [isEditing, setIsEditing] = useState(false);

    const displayName = serviceName || `${name}`;

    const label = isActive ? (
        isEditing ? (
            <span className='flex gap-5 flex-align-center'>
                <span className='text-secondary-600'>#{index + 1}</span>
                <InputBase
                    value={serviceName}
                    disabled={isDisabled}
                    onChange={e =>
                        handleEditServiceContent(id, 'Name', e.target.value)
                    }
                    onBlur={() => setIsEditing(false)}
                    onKeyDown={e => {
                        if (e.key === 'Enter') setIsEditing(false);
                    }}
                    onClick={e => e.stopPropagation()}
                    autoFocus
                    placeholder={name}
                    sx={{
                        fontSize: 'inherit',
                        padding: 0,
                        height: 'auto',
                        '& input': {
                            padding: 0,
                            height: 'auto',
                            lineHeight: 'inherit',
                        },
                    }}
                />
            </span>
        ) : (
            <span className='flex gap-10 flex-align-center'>
                <span>#{index + 1}</span>
                {displayName}
                <EditOutlined
                    sx={{
                        fontSize: 14,
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                        opacity: isDisabled ? 0.5 : 1,
                    }}
                    onClick={e => {
                        e.stopPropagation();
                        if (isDisabled) return;
                        setIsEditing(true);
                    }}
                />
            </span>
        )
    ) : (
        <span className='flex gap-5 flex-align-center'>
            <span style={{ color: 'gray' }}>#{index + 1}</span>
            {displayName}
        </span>
    );

    return <Tab label={label} {...tabProps} />;
};

export default ServiceInstanceTab;
